export const errorMessages: { [status: number]: string } = {
  400: 'Requisição inválida. Verifique os dados enviados.',
  401: 'Você não tem permissão para isto.',
  402: 'Pagamento necessário.',
  403: 'Acesso proibido.',
  404: 'Recurso não encontrado.',
  405: 'Método não permitido.',
  406: 'Requisição não aceitável.',
  407: 'Autenticação de proxy necessária.',
  408: 'Tempo de requisição esgotado.',
  409: 'Conflito nos dados enviados.',
  410: 'Recurso não está mais disponível.',
  411: 'Comprimento necessário.',
  412: 'Pré-condição falhou.',
  413: 'Carga útil muito grande.',
  414: 'URI muito longa.',
  415: 'Tipo de mídia não suportado.',
  416: 'Faixa não satisfatória.',
  417: 'Falha na expectativa.',
  422: 'Entidade não processável.',
  423: 'Recurso bloqueado.',
  424: 'Falha de dependência.',
  426: 'Atualização necessária.',
  428: 'Pré-condição requerida.',
  429: 'Muitas requisições. Tente novamente mais tarde.',
  431: 'Cabeçalhos de requisição muito grandes.',

  500: 'Erro interno do servidor. Tente novamente mais tarde.',
  501: 'Funcionalidade não implementada.',
  502: 'Gateway inválido.',
  503: 'Serviço indisponível. Tente novamente mais tarde.',
  504: 'Tempo de resposta excedido no gateway. Tente novamente mais tarde.',
  505: 'Versão HTTP não suportada.',
  507: 'Armazenamento insuficiente.',
};

export const errorSummaries: { [status: number]: string } = {
  400: 'Erro na Requisição',
  401: 'Não Autorizado',
  403: 'Acesso Negado',
  404: 'Não Encontrado',
  422: 'Erro de Validação',
  429: 'Limite Excedido',
  500: 'Erro no Servidor',
  503: 'Serviço Indisponível',
};